import { Component, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MeteringConceptModel } from '@bo-client/activation-management/shared/models/meteringConceptModel';

@Component({
  selector: 'app-metering-concept-radio-group',
  templateUrl: './metering-concept-radio-group.component.html',
  styleUrls: ['./metering-concept-radio-group.component.scss']
})
export class MeteringConceptRadioGroupComponent {
  readonly control = input.required<FormControl<MeteringConceptModel['id']>>();
  readonly items = input.required<MeteringConceptModel[]>();
}
